import { InjectionToken } from '@angular/core';
import { MenuItem } from '../../layout/domain/interfaces/MenuItem';

export const SIDE_MENU_ITEMS = new InjectionToken<Array<MenuItem>>('A token for side menu items');
